const Unrecognized = Symbol("GeometryType.Unrecognized");
const File = Symbol("GeometryType.File");

const GeometryTypes = [
    File,
    "Cube",
    "Sphere",
];

export default GeometryTypes;
export { GeometryTypes, Unrecognized, File };
